import { render, staticRenderFns } from "./formLookupTable.vue?vue&type=template&id=9c123922&"
import script from "./formLookupTable.vue?vue&type=script&lang=js&"
export * from "./formLookupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports